import React, { useEffect, useRef, useState } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// COMPONENTS
import HomePageAppointment from "./../forms/HomePageAppointment";
import SamplePrevArrow from "./Components/SliderArrows/SamplePrevArrow";
import SampleNextArrow from "./Components/SliderArrows/SampleNextArrow";

// Image imports
import SingleImg01 from "./../assets/AyurvedaAssets/images/single-img-01.jpg";
import SingleImg02 from "./../assets/AyurvedaAssets/images/single-img-02.jpg";
import Service01 from "./../assets/AyurvedaAssets/images/services/service-01.png";
import Service02 from "./../assets/AyurvedaAssets/images/services/service-02.png";
import Service03 from "./../assets/AyurvedaAssets/images/services/service-03.png";
import Service04 from "./../assets/AyurvedaAssets/images/services/service-04.png";
import Service05 from "./../assets/AyurvedaAssets/images/services/service-05.jpg";
import Service06 from "./../assets/AyurvedaAssets/images/services/service-06.jpg";
import SingleOverlay from "./../assets/AyurvedaAssets/images/single-overlay.png";
import Product01 from "./../assets/AyurvedaAssets/images/product/product-img-01.png";
import Product02 from "./../assets/AyurvedaAssets/images/product/product-img-02.png";
import Product03 from "./../assets/AyurvedaAssets/images/product/product-img-03.png";
import Product04 from "./../assets/AyurvedaAssets/images/product/product-img-04.png";
import Product05 from "./../assets/AyurvedaAssets/images/product/product-img-05.jpg";
import Product06 from "./../assets/AyurvedaAssets/images/product/product-img-06.jpg";

//
import NewsData from "../data/newsdata";
import youtubeVideos from "../data/YoutubeNews";

function useResponsiveSlides(defaultSlides = 4) {
  const [slidesToShow, setSlidesToShow] = useState(defaultSlides);

  useEffect(() => {
    const updateSlides = () => {
      const w = window.innerWidth;
      if (w < 656) setSlidesToShow(1);
      else if (w < 980) setSlidesToShow(2);
      else if (w < 1400) setSlidesToShow(3);
      else setSlidesToShow(defaultSlides);
    };
    updateSlides();
    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, [defaultSlides]);

  return slidesToShow;
}

export default function Home(props) {
  const [appointment, setAppointment] = useState("");
  const [ServiceNames, setServiceNames] = useState([]);
  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: true, // whether animation should happen only once
    });

    if (props.production == false) {
      setAppointment("http://localhost:8001");
    } else if (props.production == true) {
      setAppointment("https://appointment.bharatdhara.com");
    }

    setServiceNames(props.ServicesNames);
  }, []);

  // 🔹 Text for hero slider + right panel
  const slides = [
    {
      pretitle: "Harmony with",
      title: "Ayurveda Care",
      subtitle: "Soil to Soul — Natural Farming × Ayurveda",
      btn1: "Make an appointment",
      btn2: "Contact us",
    },
    {
      pretitle: "Welcome to the",
      title: "Ayurveda",
      subtitle:
        "From Our Farms to Your Health — Natural Farming meets Ayurveda",
      btn1: "Make an appointment",
      contact: "+123 456 7890",
      email: "contact.vedacare@gmail.com",
    },
  ];

  // 🔹 Right-hand Jiva-style icon tiles (40% panel)
  const rightPanelCtas = [
    {
      id: "consult",
      iconClass: "fa-mouse-pointer",
      label: "BOOK CONSULTATION",
      href: appointment, // adjust if you have another id
    },
    {
      id: "doctors",
      iconClass: "fa-user-md",
      label: "OUR DOCTORS",
      href: "#doctors",
    },
    {
      id: "locate",
      iconClass: "fa-map-marker-alt",
      label: "LOCATE CLINIC",
      href: "#clinic-locator",
    },
    {
      id: "products",
      iconClass: "fa-shopping-cart",
      label: "BUY PRODUCTS",
      href: "/shop",
    },
  ];

  const services = [
    {
      img: Service01,
      title: "General medicine",
      desc: "( Kayachikitsa )",
    },
    {
      img: Service02,
      title: "Pediatrics",
      desc: "( Kaumarabhritya )",
    },
    {
      img: Service03,
      title: "Detox & rejuvenation",
      desc: "( Panchkarma )",
    },
    {
      img: Service04,
      title: "Eye, ENT & dental care",
      desc: "( Kayachikitsa )",
    },
    {
      img: Service05,
      title: "Holistic wellness",
      desc: "( Kayachikitsa )",
    },
    {
      img: Service06,
      title: "Panchakarma detox",
      desc: "( Panchakarma )",
    },
  ];

  const serviceSlides = useResponsiveSlides(4);
  const productSlides = useResponsiveSlides(4);
  const newscuttingSlides = useResponsiveSlides(3);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    mobileFirst: true,
    autoplaySpeed: 5000,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const servicesettings = {
    slidesToShow: serviceSlides,
    slidesToScroll: 1,
    dots: false,
    autoplay: false,
    infinite: true,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 3 } },
      { breakpoint: 980, settings: { slidesToShow: 2 } },
      { breakpoint: 656, settings: { slidesToShow: 1 } },
    ],
  };

  // Slider settings for products
  const productSettings = {
    slidesToShow: productSlides,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    infinite: true,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 3 } },
      { breakpoint: 980, settings: { slidesToShow: 2 } },
      { breakpoint: 656, settings: { slidesToShow: 1 } },
    ],
  };

  const NewsPaperSlider = {
    dots: false,
    infinite: true,
    autoplay: true,
    arrows: true,
    speed: 500,
    slidesToShow: newscuttingSlides,
    slidesToScroll: newscuttingSlides,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 3 } },
      { breakpoint: 980, settings: { slidesToShow: 2 } },
      { breakpoint: 656, settings: { slidesToShow: 1 } },
    ],
  };

  // Use first slide text for right panel heading
  const heroText = slides[0];

  // console.log(servicesettings);
  return (
    <section>
      {/* 🔹 NEW: Jiva-style 60/40 hero section */}
      <div className="hero-section prt-bg">
        <div className="bd-hero">
          {/* LEFT 60% – your existing Dhara/Dhara Wellness slider */}
          <div className="bd-hero-left">
            <div className="hero-slider-wrapper">
              <div className="hero-slider prt-slider">
                <Slider {...settings}>
                  {slides.map((slide, idx) => (
                    <div
                      key={idx}
                      className={`hero-slide slide-${idx + 1
                        } position-relative`}
                    >
                      <div className="container">
                        <div className="row">
                          <div className="col-xl-10 col-lg-12 m-auto">
                            <div className="hero-overlay-box">
                              <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                                <i className="flaticon flaticon-verification"></i>
                              </div>
                              {/* show full hero text now */}
                              {slide.pretitle && (
                                <p className="hero-pretitle">
                                  {slide.pretitle}
                                </p>
                              )}
                              <h2 className="hero-title">{slide.title}</h2>
                              <h3 className="hero-subtitle">
                                {slide.subtitle}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>

          {/* RIGHT 40% – icons like Jiva */}
          <aside className="bd-hero-right">
            <div className="bd-hero-right-header">
              {heroText.pretitle && (
                <span className="bd-hero-pretitle">{heroText.pretitle}</span>
              )}
              <h3 className="bd-hero-title">{heroText.title}</h3>
              <p className="bd-hero-subtitle">{heroText.subtitle}</p>
            </div>

            <div className="bd-hero-grid">
              {rightPanelCtas.map((item) => (
                <a
                  key={item.id}
                  href={item.href}
                  target="_blank"
                  className="bd-hero-grid-item"
                >
                  <span className="bd-hero-icon">
                    <i className={`fa ${item.iconClass}`} aria-hidden="true" />
                  </span>
                  <span className="bd-hero-label">{item.label}</span>
                </a>
              ))}
            </div>
          </aside>
        </div>
      </div>

      {/* OLDER SECTIONS BELOW STAY SAME */}
      <div className="site-main">
        {/* about-section */}
        <section className="prt-row about-section animation clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="pr-20 res-1199-pr-0">
                  <div className="section-title">
                    <div className="title-header">
                      <h4 className="title">
                        Bharat Dhara — Gau Aadhar Se Samagra Jeevan
                      </h4>
                    </div>
                    <div className="title-desc">
                      {/* ---- Bharat Dhara Card ---- */}
                      <div>
                        <h3 style={{ margin: "0 0 0px 0" }}>
                          “गौ से ग्राम, ग्राम से भारत, भारत से विश्व — यही है
                          भारत धारा।”
                        </h3>
                        <p style={{ margin: "0px 0" }}>
                          At <b>Bharat Dhara</b>, health begins with{" "}
                          <b>Gau Mata</b>, the eternal mother. Her five sacred
                          gifts — milk, curd, ghee, gomutra, and dung — heal the
                          soil, nourish the body, and sustain the community.
                          This is the foundation of our cow-based economy, where
                          natural farming product from sacred soil to your
                          plate, Ayurveda, and wellness work as one.
                        </p>
                      </div>
                      {/* ---- /Bharat Dhara Card ---- */}
                    </div>
                  </div>
                  <div
                    data-aos="fade-left"
                    className="prt_single_image-wrapper mt-30 res-991-mt-0"
                  >
                    <img
                      width="615"
                      height="500"
                      className="img-fluid border-rad_20"
                      src={SingleImg01}
                      alt="image"
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="pl-20 res-1199-pl-0 res-991-mt-30">
                  <div
                    data-aos="fade-right"
                    className="prt_single_image-wrapper mb-40"
                  >
                    <img
                      width="615"
                      height="500"
                      className="img-fluid border-rad_20"
                      src={SingleImg02}
                      alt="image"
                    />
                  </div>
                  <div className="section-title">
                    <div className="title-desc">
                      <p>
                        Bharat Dhara is not just about health, it is about
                        belonging. Every grain of jaggery, every drop of oil,
                        every therapy flows from the soil our farmers nurture
                        with love. From their hands to your home, we bring not
                        products, but trust, purity, and healing.
                      </p>
                    </div>
                  </div>
                  <div className="row g-0">
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <ul className="prt-list prt-list-style-icon-01 pr-10 res-575-pr-0">
                        <li className="prt-list-li-content">
                          Professional doctors
                        </li>
                        <li className="prt-list-li-content">
                          Doctors who care like family
                        </li>
                        <li className="prt-list-li-content">
                          Global wellness with local heart
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <ul className="prt-list prt-list-style-icon-01">
                        <li className="prt-list-li-content">
                          Book with Ease – Online & In-Clinic Care
                        </li>
                        <li className="prt-list-li-content">
                          From villages of Bharat to families worldwide
                        </li>
                        <li className="prt-list-li-btn">
                          <a href="#">View more</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* about-section end */}

      {/* ⭐ How Bharat Dhara Care Works – 5-step process */}
<section className="bd-process-section animation clearfix">
  <div className="container">
    <div className="section-title title-style-center_text mb-50">
      <div className="title-header">
        <h2 className="cta-title bd-process-heading">
          How Bharat Dhara Care Works
        </h2>
        <h4 className="cta-titlepre bd-process-subheading">
          Soil to Soul — Natural Farming × Ayurveda
        </h4>
      </div>
    </div>

    <div className="bd-process-row">
      {/* 01 */}
      <div className="bd-process-col">
        <div className="bd-process-card">
          <span className="bd-process-number">01</span>
          <div className="bd-process-icon">
            <i className="fa fa-user-md" aria-hidden="true" />
          </div>
          <h4 className="bd-process-title">Connect</h4>
          <p className="bd-process-text">
            Call, WhatsApp or book your consultation online.
          </p>
        </div>
      </div>

      {/* 02 */}
      <div className="bd-process-col">
        <div className="bd-process-card">
          <span className="bd-process-number">02</span>
          <div className="bd-process-icon">
            <i className="fa fa-stethoscope" aria-hidden="true" />
          </div>
          <h4 className="bd-process-title">Health &amp; Prakriti Analysis</h4>
          <p className="bd-process-text">
            Your history, reports and Vata–Pitta–Kapha balance are assessed.
          </p>
        </div>
      </div>

      {/* 03 */}
      <div className="bd-process-col">
        <div className="bd-process-card">
          <span className="bd-process-number">03</span>
          <div className="bd-process-icon">
            <i className="fa fa-users" aria-hidden="true" />
          </div>
          <h4 className="bd-process-title">Health Coach</h4>
          <p className="bd-process-text">
            Health Coach is assigned, reviews your case, and books your expert appointment.
          </p>
        </div>
      </div>

      {/* 04 */}
      <div className="bd-process-col">
        <div className="bd-process-card">
          <span className="bd-process-number">04</span>
          <div className="bd-process-icon">
            <i className="fa fa-list-alt" aria-hidden="true" />
          </div>
          <h4 className="bd-process-title">Personalised Plan</h4>
          <p className="bd-process-text">
          Doctor consultation, therapy, Panchakarma, plus medicines, diet, lifestyle and Rasayana support—tailored just for you.
          </p>
        </div>
      </div>

      {/* 05 */}
      <div className="bd-process-col">
        <div className="bd-process-card">
          <span className="bd-process-number">05</span>
          <div className="bd-process-icon">
            <i className="fa fa-leaf" aria-hidden="true" />
          </div>
          <h4 className="bd-process-title">Follow-Up &amp; Support</h4>
          <p className="bd-process-text">
            Regular follow-up with clean Bharat Dhara farm-to-plate products.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
{/* ⭐ 5-step process end */}



        {/* 🔴 YouTube Videos Section (mobile horizontal, desktop grid) */}
        <section className="clearfix" style={{ padding: "20px 0px 20px 0px" }}>
          <div className="container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 className="title mb-0">
                Customer Success Stories - Slide right for more
              </h3>
              <a
                href="https://www.youtube.com/@Bharatdharacares"
                target="_blank"
                rel="noreferrer"
                className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor d-none d-md-inline-block"
              >
                Watch all videos →
              </a>
            </div>

            <div>
              <Slider {...NewsPaperSlider}>
                {youtubeVideos.map((video) => (
                  <div>
                    <a
                      key={video.title}
                      href={video.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        width: "100%",
                        display: "block",
                        position: "relative",
                      }}
                      className="bg-white rounded-lg flex-shrink-0 transform hover:scale-95 transition-transform duration-300 snap-center w-[328px]"
                    >
                      <img
                        style={{ width: "100%" }}
                        src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                        alt={video.title}
                        className="rounded-lg mb-2 w-full h-[165px] object-contain"
                      />
                      <div className="font-semibold text-sm text-center line-clamp-2">
                        {video.title}
                      </div>
                    </a>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </section>

        {/* blog-section */}
        <section className="blog-section animation clearfix">
          <div className="container">
            <div className="row"></div>
            {/* row */}
            <div className="row pt-30 pb-30" data-aos="fade-up">
              <div className="col-12">
                <div>
                  {/* section title */}
                  <div className="section-title mb-45 res-991-mb-30">
                    <div className="title-header">
                      <h2 className="blog-title">Our latest stories</h2>
                    </div>
                    <div className="title-desc">
                      <p>
                        Stay informed and inspired with our freshest content,
                        delivering insights and stories that matter.
                      </p>
                      <a
                        className="prt-btn btn-inline prt-btn-color-darkcolor btn-underline"
                        href="#"
                      >
                        View all stories
                      </a>
                    </div>
                  </div>
                  {/* section title end*/}
                </div>
              </div>
              <div className="slider-container">
                <Slider {...NewsPaperSlider}>
                  {NewsData.length &&
                    NewsData.map((item, index) => {
                      return (
                        <>
                          <div>
                            {/* featured-imagebox-post */}
                            <div className="featured-imagebox featured-imagebox-post style1">
                              <div className="featured-thumbnail">
                                <img
                                  width={303}
                                  height={300}
                                  className="img-fluid"
                                  src={item.img}
                                  style={{ height: "300px" }}
                                  alt={item.title}
                                />
                              </div>
                              {/* featured-content */}
                              <div className="featured-content">
                                <div className="featured-content-inner">
                                  <div className="post-header">
                                    {/* post-meta */}
                                    <div className="post-meta">
                                      <span className="prt-meta-line category">
                                        NEWS and Media
                                      </span>
                                    </div>
                                    {/* post-meta end */}
                                    <div className="post-title featured-title">
                                      <h3>
                                        <a href="blog-single.html">
                                          {item.title}
                                        </a>
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                                {/* featured-content end */}
                              </div>
                            </div>
                            {/* featured-imagebox-post end */}
                          </div>
                        </>
                      );
                    })}
                </Slider>
              </div>
              {/* row end */}
            </div>
          </div>
        </section>
        {/* blog-section end */}

        {/* service-section */}
        <section className="prt-row padding_top_zero-section service-section animation clearfix">
          <div className="container">
            <Slider {...servicesettings} data-aos="fade-up">
              {services.map((service, i) => (
                <div key={i}>
                  <div className="featured-imagebox featured-imagebox-service style1">
                    <div className="featured-thumbnail">
                      <img
                        width="303"
                        height="151"
                        className="img-fluid"
                        src={service.img}
                        alt={service.title}
                      />
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h3>
                          <a href="service-details.html">{service.title}</a>
                        </h3>
                      </div>
                      <div className="featured-desc">
                        <p>{service.desc}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </section>
        {/* service-section end */}

        {/* cta-section */}
        <section className="prt-row prt-bg bg-base-grey prt-bgimage-yes bg-img1 cta-section position-relative animation clearfix">
          <div className="prt-row-wrapper-bg-layer prt-bg-layer bg-base-grey"></div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-single-image-overlay">
                  <img
                    width="480"
                    height="491"
                    className="img-fluid"
                    src={SingleOverlay}
                    alt="overlay"
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="section-title title-style-center_text">
                  <div className="title-header">
                    <h2 className="cta-title">Need Help?</h2>
                    <h3 className="cta-titlepre">
                      Book your Ayurvedic Consultation today
                    </h3>
                  </div>
                  <div className="cta-bnt mt-40 fadeup-amin">
                    <a
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-skincolor"
                      href="contact-us.html"
                    >
                      +91-7060112355
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* cta-section end */}

        {/* product-section */}
        <section className="prt-row product-section clearfix">
          <div className="container">
            <div className="row row-equal-height">
              {/* Featured icon boxes */}
              {[
                {
                  icon: "flaticon-organic-product",
                  title: "100% Natural",
                  desc: "100% Natural products",
                  style: "bg-base-dark",
                },
                {
                  icon: "flaticon-quality",
                  title: "Certified medicine",
                  desc: "Reliable medical treatments",
                  style: "bg-base-skin",
                },
                {
                  icon: "flaticon-hourglass",
                  title: "Healing Journeys That Inspire",
                  desc: "From chronic pain relief to improved lifestyle balance.",
                  style: "bg-base-dark",
                },
              ].map((item, i) => (
                <div className="col-lg-4 col-md-6 col-sm-12" key={i}>
                  <div
                    className={`featured-icon-box icon-align-before-content style1 ${item.style}`}
                  >
                    <div className="featured-icon">
                      <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                        <i className={`flaticon ${item.icon}`}></i>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h3>{item.title}</h3>
                      </div>
                      <div className="featured-desc">
                        <p>{item.desc}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <Slider {...productSettings}>
              {[
                Product01,
                Product02,
                Product03,
                Product04,
                Product05,
                Product06,
              ].map((product, i) => (
                <div key={i} data-aos="fade-up" className="px-2">
                  <div className="featured-imagebox featured-imagebox-product style1">
                    <div className="featured-thumbnail">
                      <img
                        width="303"
                        height="280"
                        className="img-fluid"
                        src={product}
                        alt={`Product ${i + 1}`}
                      />
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h3>
                          <a href="#">
                            {
                              [
                                "Acupuncture slipper",
                                "Massage stone",
                                "Teak massager",
                                "Wooden bodycalf",
                                "Herbal medicine",
                                "Massage brush",
                              ][i]
                            }
                          </a>
                        </h3>
                      </div>
                      <div className="featured-desc">
                        <p>
                          <span>
                            <a href="#">
                              ${[329, 120, 160, 100, 100, 80][i]}.00
                            </a>
                          </span>
                          <a href="#">${[149, 80, 100, 90, 90, 50][i]}.00</a>
                        </p>
                      </div>
                      <div className="prt-product-btn">
                        <a
                          className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor mr"
                          href="#"
                        >
                          Buy now
                        </a>
                        <a
                          className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                          href="#"
                        >
                          Add to card
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className="row">
            <div className="col-xl-7 col-lg-10 col-md-12 m-auto">
              <div className="prt-product-text">
                <p>
                  Explore a wide selection of products in our inventory
                  <a
                    className="prt-btn btn-inline prt-btn-color-whitecolor btn-underline"
                    href="#"
                  >
                    View all products
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* product-section end */}

        <HomePageAppointment ServiceNames={ServiceNames} />

        {/* info-section */}
        <section className="prt-row padding_zero-section prt-bg bg-base-skin info-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-md-12">
                <div className="prt-info-main-block">
                  <div className="info_btn mr-30 res-767-mb-15">
                    <a
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                      href="#"
                    >
                      COVID-19 resources
                    </a>
                  </div>
                  {/* featured-icon-box */}
                  <div className="featured-icon-box icon-align-before-content style2">
                    <div className="featured-icon">
                      <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                        <i className="flaticon-alert"></i>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h3>Get The Health package</h3>
                      </div>
                      <div className="featured-desc">
                        <p>
                          What you need to know about the 2019 - 2023 fly
                          season.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* featured-icon-box end */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* info-section end */}

        {/* cta-section */}
        <section className="prt-row prt-bg bg-base-grey padding_zero-section cta-section01 clearfix">
          <div className="container">
            <div className="row">
              <div className="col-xl-10 col-lg-12 m-auto">
                <div className="prt-cta-mainblock">
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="prt-cta-call">
                      <p>
                        Looking for consultation?{" "}
                        <a href="tel:1234567890">
                          <br />
                          call +91-7060112355
                        </a>
                      </p>
                    </div>
                    <div className="prt-cta-title">
                      <h3>
                        We are <span>Traditional</span> ayurveda company
                      </h3>
                    </div>
                  </div>
                  <div className="prt-cta-btn res-1199-mt-30">
                    <a
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor ml-20"
                      href="contact-us.html"
                    >
                      Contact us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* cta-section end */}
      </div>
    </section>
  );
}
